/* H05 editor-only enhancement. Preserve V2.1 storefront scrolling and product tabs. */
(() => {
  if (window.__namikiH05EditorFix) return;
  window.__namikiH05EditorFix = true;
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const root = target.closest('#namiki-home-h05');
    if (!root) return;
    const carousel = root.querySelector('[data-n2-marquee]');
    const view = root.querySelector('.n2-review-viewport');
    const card = target.closest('.n2-review-card') || target.querySelector('.n2-review-card');
    if (!carousel || !view || !card || card.closest('.n2-review-clone')) return;
    const toggle = carousel.querySelector('[data-review-toggle]');
    if (toggle && toggle.getAttribute('aria-pressed') !== 'true') toggle.click();
    const inset = parseFloat(getComputedStyle(view).paddingLeft) || 0;
    const left = view.scrollLeft + card.getBoundingClientRect().left - view.getBoundingClientRect().left - inset;
    view.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
  });
})();
